import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components/Button';
import { Select } from '../../components/Select';

/**
 * Komponentenübersicht („Living Style Guide"): zeigt die Bausteine der Oberfläche und
 * dient als Prüfstand, dass sie unter der strikten Content-Security-Policy funktionieren.
 */
export function ComponentsPage() {
  const { t } = useTranslation();
  const [value, setValue] = useState<string | null>(null);
  const options = [
    { id: 'digital', label: t('components.optionDigital') },
    { id: 'print', label: t('components.optionPrint') },
  ];
  const selectedLabel = options.find((option) => option.id === value)?.label;

  return (
    <section>
      <h1>{t('components.title')}</h1>
      <p>{t('components.intro')}</p>
      <h2>Button</h2>
      <p>
        <Button>{t('components.primaryButton')}</Button>{' '}
        <Button variant="secondary">{t('components.secondaryButton')}</Button>
      </p>
      <h2>Select</h2>
      <Select
        label={t('components.selectLabel')}
        placeholder={t('components.selectPlaceholder')}
        options={options}
        value={value}
        onChange={setValue}
      />
      {selectedLabel && (
        <p data-testid="selected-value">{t('components.selected', { value: selectedLabel })}</p>
      )}
    </section>
  );
}
